import React, { FC } from "react";
import {
  useNotificationsCount,
  useSystemNotificationsFetchStatus,
  useTemplateNotificationsFetchStatus,
} from "../../../../../store/notifications/useSelectors";
import { isLoading } from "../../../../../utils/fetching";
import Notifications from "./Notifications";

const Container: FC = () => {
  const notificationCount = useNotificationsCount();

  const systemStatus = useSystemNotificationsFetchStatus();
  const templateStatus = useTemplateNotificationsFetchStatus();
  const loading = isLoading(systemStatus) || isLoading(templateStatus);

  return (
    <Notifications notificationCount={notificationCount} isLoading={loading} />
  );
};

Container.displayName = `Container(${Notifications.displayName})`;

export default Container;
